import { Einheit } from 'app/models/core/einheit.model';
import { BnrGpPosModel } from '../bnr.gp.pos.model';
import { PosUnDef } from '../gp';
const posDef: BnrGpPosModel[] = [];

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'ausMaxi',
		posText: 'Hardwareadministration im Verantwortungsbereich',
		einheit: Einheit.quali,
		posDesc: `Nachhaltiges und wirtschaftliches Handeln bei administrativen Tätigkeiten im Bereich Hardware im Verantwortungsbereich. Planung und Durchführung von praktikablen Arbeitsmustern, insbesondere bei der Bestellung und dem Abbau von Hardware.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'ausMaxi',
		posText: 'Vertreteraktivierung in den Wachstumsdimensionen',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und Ansprechpartner:in für die Vertriebseinheiten innerhalb der VD für den strategischen Einsatz aller digitalen und analogen Instrumente der Wachstumsdimensionen. Unterstützung und Beratung in der Nutzung der Instrumente durch gezielte Einsteuerung und Multiplikation von Neuerungen und Best Practices.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'ausMaxi',
		posText: 'Agenturprozesse und Agenturadministration',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und Ansprechpartner:in im Verantwortungsbereich für die Gestaltung effizienter Agenturabläufe und -prozesse, Verantwortung für die Etablierung von neuen Anwendungen durch gezielte Einsteuerung von Neuerungen und Best-Practices.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10010,
		group: 'max8k',
		posText: 'Sichtbar sein digital.persönlich - Steigerung der digitalen Sichtbarkeit I',
		berichtePath: 'kunde/sm/gupmultigp/',
		einheit: Einheit.proz,
		boniStufen: 2,
		posDesc: `Steigerung der Anzahl GV/HV mit kontinuierlichem Zuwachs an Google Bewertungen im Verantwortungsbereich Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10020,
		group: 'max8k',
		posText: 'Sichtbar sein digital.persönlich - Steigerung der digitalen Sichtbarkeit II',
		berichtePath: 'kunde/sm/viewsmultigp/',
		einheit: Einheit.proz,
		boniStufen: 2,
		posDesc: `Anzahl GV/HV mit mehr als 30.000 Sichtkontakten über die Social Media Kanäle Facebook und Instagram. Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max8k',
		posText: 'Jeden Kontakt nutzen I - Schulung und Unterstützung bei der Einrichtung des neuen technischen Arbeitsplatzes',
		berichtePath: 'bestand/fit/amisnowaufgaben/',
		einheit: Einheit.quali,
		posDesc: `Beratung von Vertretungen und Vertriebseinheiten im Verantwortungsbereich in der Umsetzung des neuen technischen Arbeitsplatzes. Befähigung in der Verwendung durch Einsatz von geeigneten Maßnahmen zum sicheren Umgang zur Steigerung der Nettovertriebszeit.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max8k',
		posText: 'Jeden Kontakt nutzen II - Unterstützung bei der fachlichen Weiterentwicklung von AMIS.NOW',
		berichtePath: 'bestand/fit/amisnowaufgaben/',
		einheit: Einheit.quali,
		posDesc: `Befähigung von Vertretungen und Vertriebseinheiten im Verantwortungsbereich in der Umsetzung von AMIS.NOW im Vertriebsalltag. Identifikation und Multiplikation von Best Practices beim erfolgreichen Einsatz von AMIS.NOW. Befähigung und Beratung beim Einsatz von AMIS.NOW Aufgaben im Verantwortungsbereich.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max8k',
		posText: 'Jeden Kontakt nutzen III - Förderung von Vertriebschancen im Agenturteam',
		berichtePath: 'bestand/fit/amisnowaufgaben/',
		einheit: Einheit.quali,
		posDesc: `Multiplikator:in und Ansprechpartner:in für Service-to-Sale. Förderung von Vertriebschancen im gesamten Agenturteam durch Einsteuerung und Nachhalten geeigneter Maßnahmen im Verantwortungsbereich.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10030,
		group: 'max8k',
		posText: 'Jeden Kunden kontaktieren - Steigerung der Cross-Selling-Quote und Kundenbindung',
		berichtePath: 'kunde/akuma/gp/',
		einheit: Einheit.proz,
		posDesc: `Anzahl GV/HV mit wiederkehrender AKUMA Nutzung in der VD plus Anzahl GV/HV an AKUMA.Prime. (wiederkehrende AKUMA Planer Nutzung von mindestens 12 Wochen im Jahr 2026) Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 2310160, // wird geliefert
		group: 'max8k',
		posText: 'Immer da sein - Neuanmeldungen Meine Allianz',
		berichtePath: 'bestand/adz/fit/maz/',
		einheit: Einheit.stck,
		posDesc: `Steigerung der Durchdringung von Kunden mit Meine Allianz im Bestand Basis Jahresanfangsbestand 01.01.2026`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: PosUnDef,
		group: 'max8k',
		posText: 'Immer da sein - Öffnungszeiten effektiv verlängern',
		planKey: 'openinghours',
		einheit: Einheit.quali,
		posDesc: `Förderung und Multiplikation von Serviceleistungen im Bereich Inbound. Förderung von Erreichbarkeit im Verantwortungsbereich durch Einsteuerung und Nachhalten geeigneter Maßnahmen.`,
	}),
);

posDef.push(
	new BnrGpPosModel({
		year: 2026,
		posId: 10040,
		group: 'max8k',
		posText: 'Neue Kunden finden - Förderung der Neukundengewinnung',
		berichtePath: 'kunde/leadnow/consecutive/',
		einheit: Einheit.proz,
		boniStufen: 2,
		posDesc: `Steigerung der Neukundengewinnung mit AMIS.NOW.Leads. Anzahl Agenturen von AMIS.NOW.Leads im Verantwortungsbereich mit einer Teilnahme von mind. 12 Wochen am Stück Stichtag der Bemessungsgrundlage für das Jahresziel ist der GV/HV Bestand zum 01.01.2026`,
	}),
);
export const EdpPositionen = posDef;
